import { render, staticRenderFns } from "./ModuleSlidebar.vue?vue&type=template&id=a7a74c36"
import script from "./ModuleSlidebar.vue?vue&type=script&lang=js"
export * from "./ModuleSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports